import { RuntimeName } from './runtime';

/* ==========================================================
   Workspace View（视图枚举）
   🔒 冻结后只新增不修改
========================================================== */
export enum WorkspaceView {
  Cockpit = 'cockpit',
  Trading = 'trading',
  Knowledge = 'knowledge',
  Business = 'business',
  Agent = 'agent',
  Calendar = 'calendar',
  Settings = 'settings',
  /** P1-2：工作流仪表板 */
  Workflow = 'workflow',
}

/* ==========================================================
   Workspace Action（行为枚举）
   所有 Workspace 操作统一管理
========================================================== */
export enum WorkspaceAction {
  SwitchView = 'switchView',
  Refresh = 'refresh',
  UpdateWidgets = 'updateWidgets',
  Reset = 'reset',
}

/* ==========================================================
   Workspace State（运行时状态）
========================================================== */
export interface WorkspaceState {
  currentView: WorkspaceView;
  previousView?: WorkspaceView;
  loading: boolean;
  updatedAt: string;
}

/* ==========================================================
   Workspace Descriptor（视图描述符）
   包含视图的完整元信息
========================================================== */
export interface WorkspaceDescriptor {
  view: WorkspaceView;
  title: string;
  runtime: RuntimeName;
  widgets: string[];
  keepAlive?: boolean;
}

/* ==========================================================
   Workspace Event（事件契约）
========================================================== */
export interface WorkspaceEvent {
  action: WorkspaceAction;
  descriptor?: WorkspaceDescriptor;
  payload?: unknown;
  timestamp: string;
}

/* ==========================================================
   Workspace Event Listener
========================================================== */
export type WorkspaceEventListener = (event: WorkspaceEvent) => void;

/* ==========================================================
   Workspace View Metadata（视图元信息）
   所有视图的静态配置
========================================================== */
export const WorkspaceViewMeta: Record<WorkspaceView, Omit<WorkspaceDescriptor, 'view'>> = {
  [WorkspaceView.Cockpit]: {
    title: 'CEO Cockpit',
    runtime: RuntimeName.Hermes,
    widgets: ['kpi', 'runtime', 'agent'],
    keepAlive: true,
  },
  [WorkspaceView.Trading]: {
    title: 'Trading',
    runtime: RuntimeName.Quant,
    widgets: ['pnl', 'positions', 'risk'],
    keepAlive: true,
  },
  [WorkspaceView.Knowledge]: {
    title: 'Knowledge',
    runtime: RuntimeName.Knowledge,
    widgets: ['search', 'graph', 'preview'],
    keepAlive: true,
  },
  [WorkspaceView.Agent]: {
    title: 'Agent',
    runtime: RuntimeName.Agent,
    widgets: ['status', 'logs', 'tasks'],
    keepAlive: false,
  },
  [WorkspaceView.Business]: {
    title: 'Business',
    runtime: RuntimeName.Business,
    widgets: [],
    keepAlive: false,
  },
  [WorkspaceView.Calendar]: {
    title: 'Calendar',
    runtime: RuntimeName.Scheduler,
    widgets: [],
    keepAlive: false,
  },
  [WorkspaceView.Settings]: {
    title: 'Settings',
    runtime: RuntimeName.Hermes,
    widgets: [],
    keepAlive: false,
  },
  [WorkspaceView.Workflow]: {
    title: 'Workflow',
    runtime: RuntimeName.Workflow,
    widgets: ['visualizer', 'executions'],
    keepAlive: true,
  },
};